import React, { useEffect, useState } from "react";
import ECLLoader from "../../../../Widgets/ECLLoader/ECLLoader";
import { endpointRequest } from "../../../../../utilities/requests";
import ECLTable from "../../../../Widgets/ECLTable/ECLTable";
import { translate } from "../../../../../utilities/Translate";
import { ECLUnsafeStringifyULID } from "../../../../../utilities/ECLUUID";

export default function AskTable(props) {
   const [table, setTable] = useState(null);
   const [error, setError] = useState(null);
   const [loading, setLoading] = useState(true);

   useEffect(() => {
      async function fetchAITable() {
         let data;
         try {
            data = await endpointRequest(
               props.parentObject ? props.parentObject : null,
               props.block ? props.block.id : null,
               props.block
                  ? props.block.session
                  : sessionStorage.getItem("AISession"),
               props.endpoint + "_content",
            );

            setTable({
               rowData: data.rows.map((r) => {
                  return { row: r };
               }),
               columnSettings: data.columns.map((c, i) => {
                  let customFormatting;
                  if (c.name === "id") {
                     customFormatting = (rowIndex, value) => {
                        return (
                           <p
                              title={ECLUnsafeStringifyULID(value)}
                              className="string-cell cell-trunc"
                           >
                              {ECLUnsafeStringifyULID(value)}
                           </p>
                        );
                     };
                  }
                  return {
                     label: c.name,
                     id: c.name + i,
                     width: 200,
                     customFormatting: customFormatting,
                  };
               }),
               tableSettings: {
                  columnOrder: data.columns.map((c, i) => c.name + i),
                  rowHeight: 35,
                  tableHeight: 300,
               },
            });
            setLoading(false);
         } catch (error) {
            console.error(error);
            setError(translate("Error loading table"));
         }
      }
      fetchAITable();
   }, []);

   if (loading || error || !table) {
      return <ECLLoader message={error} />;
   }

   return (
      <ECLTable
         rowData={table.rowData}
         columnSettings={table.columnSettings}
         tableSettings={table.tableSettings}
      />
   );
}
